import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';
import IncidentCellList from './IncidentCellList/IncidentCellListUpload';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const GEOFiles = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Incident CellList">
			<Header module="Incident CellList" view="Incident CellList" />
			<IncidentCellList className={classes.content} />
		</Page>
	);
};

export default GEOFiles;
